// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm11(){

  var stuwdruk = $('.acf-field').find("[data-name='form11_stuwdruk']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form11_zone']").find('label.selected > input[type="radio"]').val();
  var ankers_hoh = $('.acf-field').find("[data-name='form11_anker_hoh']").find(':input').val();
  var hoogte_element = $('.acf-field').find("[data-name='form11_hoogte']").find(':input').val();

  var afstand_a1 = $('.acf-field').find("[data-name='form11_a1']").find(':input').val();
  var afstand_a2 = $('.acf-field').find("[data-name='form11_a2']").find(':input').val();
  var afstand_b1 = $('.acf-field').find("[data-name='form11_b1']").find(':input').val();
  var afstand_b2 = $('.acf-field').find("[data-name='form11_b2']").find(':input').val();

  var breedte_anker = $('.acf-field').find("[data-name='form11_breedte']").find(':input').val();
  var gekozen_dikte = $('.acf-field').find("[data-name='form11_dikte']").find(':input').val();

  var staal_kwaliteit = $('.acf-field').find("[data-name='form11_staalkwaliteit']").find('label.selected > input[type="radio"]').val();
  var kwaliteit = $('.acf-field').find("[data-name='form11_kwaliteit']").find('label.selected > input[type="radio"]').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form11Calculate',
      stuwdruk: stuwdruk,
      zone: zone,
      ankers_hoh: ankers_hoh,
      hoogte_element: hoogte_element,
      afstand_a1: afstand_a1,
      afstand_a2: afstand_a2,
      afstand_b1: afstand_b1,
      afstand_b2: afstand_b2,
      breedte_anker: breedte_anker,
      gekozen_dikte: gekozen_dikte,
      staal_kwaliteit: staal_kwaliteit,
      kwaliteit: kwaliteit,
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form11Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });

}

$(document).ready(function(){

  $('#form11Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form11Calc .acf-form-submit').append('<input type="submit" id="calculate_form11" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form11').click(function(e){
    e.preventDefault();
    calculateForm11();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form11.js